import L from 'leaflet'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import 'leaflet-polylinedecorator'

/**
 * 箭头延伸
 */
const TrackShipSymbol = L.Symbol.ArrowHead.extend({
  hdg: 0,
  _buildArrowPath(layer: any, point: any) {
    const points: L.Point[] = []
    const projected = point.project(layer.latLng)
    // 获取船只模板配置
    const ship = this.options.ship
    let shipTemplate = CanvasShipUtils.getShipTemplater(
      point,
      ship,
      13,
      this.options.shipTemplaterThree
    )
    // 根据缩放级别调整船只模板尺寸
    shipTemplate = CanvasShipUtils.sizeZoomShipTemplater(
      shipTemplate,
      this.options.shipTemplaterZoom
    ) as any

    const centerPoint = [projected.x, projected.y]

    // 计算中心坐标偏移量
    const offsetX = centerPoint[0] - shipTemplate.centerXY[0]
    const offsetY = centerPoint[1] - shipTemplate.centerXY[1]
    const angle = layer.heading
    // if (this.hdg && this.hdg > 0) {
    //   angle = this.hdg
    // }
    // console.log(angle)
    // 遍历船只模板的每个点，旋转并转换为地图坐标
    for (let i = 0; i < shipTemplate.area.length; i++) {
      const x = shipTemplate.area[i][0] + offsetX
      const y = shipTemplate.area[i][1] + offsetY
      const rotatedPoint = CanvasShipUtils.pointRotate(
        centerPoint,
        [x, y],
        angle
      )
      points.push(
        point.unproject(new L.Point(rotatedPoint[0], rotatedPoint[1]))
      )
    }

    return points
  },
})
const trackShipSymbol = (options = {}) => {
  return new TrackShipSymbol(
    Object.assign(
      {
        shipTemplaterThree: CanvasShipUtils.shipTemplaterThree,
        shipTemplaterZoom: 1.5,
      },
      options
    )
  )
}
interface TrackPlayServiceOptions {
  playSpeed: number
  playFrequency: number
  beginTime: number
  showPlayObjLable: boolean
  playObjPlayerItems: string[]
  playObjLabelItems: string[]
  shipTemplaterThree: any
  shipTemplaterZoom: number
  isPlayerDraggable: boolean
  isVisiableWithNoSignal: boolean
  isVisiableOutOfBounds: boolean
  isVisiableShipTrack: boolean
  shipTrackMaxInterval: number
  onCloseRemoveAllTrack: boolean
  playCallBack?: ((currentTimePosition: number, params: any) => void) | null
  playGPSCallBack?: ((...params: any) => void) | null
  closeCallback?: (() => void) | null
  fullScreenCallback?: (() => void) | null
  shipListClickCallback?: ((...params: any) => void) | null
  labelOptionCallback?: ((...params: any) => void) | null
}
class TrackPlayServiceImpl {
  options: TrackPlayServiceOptions = {
    playSpeed: 1,
    playFrequency: 100,
    beginTime: 0,
    showPlayObjLable: true,
    playObjPlayerItems: ['name', 'mmsi'], //'hdg', 'cog', 'sog'
    playObjLabelItems: ['name', 'mmsi'], //'hdg', 'cog', 'sog'
    shipTemplaterThree: {
      name: 'three',
      area: [
        [0, 0],
        [6, -16],
        [12, 0],
        [6, -4],
        [0, 0],
      ],
      centerXY: [6, -8],
      headXY: [6, -16],
      headXY2: [6, -31],
    },
    shipTemplaterZoom: 1.5,
    isPlayerDraggable: true,
    isVisiableWithNoSignal: true,
    isVisiableOutOfBounds: false,
    isVisiableShipTrack: false,
    shipTrackMaxInterval: 0,
    onCloseRemoveAllTrack: true,
  }
  playState: boolean
  requestingData: boolean
  currentTimePosition: number
  playSpeed: number
  playSpeedList: number[]
  playSpeedOne: number
  minTime: number
  maxTime: number
  playTrackItems: {
    [key: string]:
      | any
      | {
          data: {
            [time: number]: L.LatLngExpression
          }
          dataInfo: {
            [time: number]: any
          }
        }
  }
  playObjBMD: any
  playObjHMD: any
  maxSupplementPointInterval: number
  step: number
  curStep: number
  shipHistoryTrackStyle: {
    renderer: any
    color: string
    fillColor: string
    weight: number
  }
  shipHistoryTrackData: any
  shipHistoryTrackLine: any
  _map: any
  _hasLoadDone: boolean
  _loadDataPercent: number
  budian_timers: any
  _playObjLabelTemplater: {
    name: string
    mmsi: string
    hdg: string
    sog: string
    cog: string
  } = {
    name: '<div class="trackPlay_label trackPlay_label_name">船名：{value}</div>',
    mmsi: '<div class="trackPlay_label trackPlay_label_mmsi">MMSI：{value}</div>',
    hdg: '<div class="trackPlay_label trackPlay_label_hdg">航首向：{value}度</div>',
    sog: '<div class="trackPlay_label trackPlay_label_sog">速度：{value}节</div>',
    cog: '<div class="trackPlay_label trackPlay_label_cog">航迹向：{value}度</div>',
  }
  isMousedown = false
  playBtn?: HTMLButtonElement
  playerCtime?: HTMLElement
  playerEtime?: HTMLElement
  playerDiv?: HTMLDivElement
  playerTitleDiv?: HTMLDivElement
  playerTitleOption?: HTMLDivElement
  playerTitleBtn?: HTMLDivElement
  playerTitleFullScreen?: HTMLDivElement
  playerTiao?: HTMLDivElement
  playerJindu?: HTMLDivElement
  playSpeedSelectUL: any
  playSpeedText: any
  playSpeedSelectlis: HTMLElement[] = []
  playerTiaoW = 0
  playerYuan: any
  trackInfo_leftBtn: any
  trackInfo_rightBtn: any
  trackInfoViewCount = 1
  shipListBtn?: HTMLElement
  playSate: any
  playerTimeDiv?: HTMLDivElement
  playSpeedDiv?: HTMLDivElement
  playSpeedImg?: HTMLDivElement
  shipListBtnText?: HTMLDivElement
  trackInfoSHBtn: any
  trackInfoDiv?: HTMLDivElement
  trackInfo_center?: HTMLDivElement
  trackInfoCIndex = 0
  shipListDiv?: HTMLDivElement
  shipList_title?: HTMLDivElement
  shipList_content?: HTMLDivElement
  shipList_foot?: HTMLDivElement
  playerPercentage?: number
  playerMinValue?: number
  playerMaxValue?: number
  draggable: any
  trackInfoCenter: any
  playerOptionDiv?: HTMLDivElement

  constructor(map: any, options?: Partial<TrackPlayServiceOptions>) {
    this.options = Object.assign(this.options, options)
    this.playState = false
    this.requestingData = false
    this.currentTimePosition = 0
    this.playSpeed = 1
    this.playSpeedList = [1, 2, 6, 12, 30, 60, 120, 240, 480]
    this.playSpeedOne = 1
    this.minTime = 0
    this.maxTime = 0
    this.playTrackItems = {}
    this.playObjBMD = {}
    this.playObjHMD = {}
    this.maxSupplementPointInterval = 600
    this.step = 0
    this.curStep = 0
    this.shipHistoryTrackStyle = {
      renderer: L.canvas(),
      color: 'red',
      fillColor: 'rgba(255,0,0,0.2)',
      weight: 1.5,
    }
    this.shipHistoryTrackData = {}
    this.shipHistoryTrackLine = {}
    this._map = map
    this._hasLoadDone = false
    this._loadDataPercent = 0
    this.budian_timers = {}
    // 检测引入脚本
    // this._checkDependence()
    this.setPlaySpeed(this.options.playSpeed)
    this.currentTimePosition = this.options.beginTime
    this._createPlayerHtml()
  }

  addPlayTrack(trackId: string | null, isAutoPlay = true): void {
    if (trackId !== null) {
      const trackItem = this._map.trackService.get(trackId)
      return this.addPlayTrackByItem(trackId, trackItem, isAutoPlay)
    }
    for (const trackId in this._map.trackService.items) {
      const trackItem = this._map.trackService.items[trackId]
      if (
        trackItem !== null &&
        trackItem.options.isEnablePlayer === 1 &&
        trackItem.symbol !== null
      ) {
        this.addPlayTrackByItem(trackId, trackItem, isAutoPlay)
      }
    }
  }

  addPlayTrackByItem(trackId: string, trackItem: any, isAutoPlay = true): any {
    if (!trackItem) return null
    trackItem.trackId = trackId
    trackItem.isAdd = trackItem.isAdd === 0
    trackItem.requesting = trackItem.requesting === 0
    trackItem.isBMD = trackItem.isBMD !== null && trackItem.isBMD
    if (trackItem.isBMD && !this.playObjBMD[trackId]) {
      this.playObjBMD[trackId] = true
    }
    this.requestingData = trackItem.requesting
    if (trackId in this.playTrackItems && !trackItem.isAdd) {
      this.removeTracks([trackId])
    }
    CanvasShipUtils.latlngsFrom180(trackItem.data)
    const supplementedLatLng = this._supplementLatLng(trackItem)
    if (supplementedLatLng === null) return null
    supplementedLatLng.trackid = trackId
    this.playTrackItems[trackId] = supplementedLatLng
    this._resetMinMaxTime(
      trackItem.startTime,
      trackItem.endTime,
      !trackItem.isAdd
    )
    this.setPlayerDisplay(false, trackItem.isAdd)
    this._playTrackInfoCarousel()
    if (isAutoPlay) {
      this.playStart(0, false)
    } else {
      this.playStop()
    }
    return supplementedLatLng
  }

  setDataLoadDone(hasLoadDone: boolean, loadPercent = 0): boolean {
    this._hasLoadDone = hasLoadDone
    this._loadDataPercent = loadPercent || 0
    if (hasLoadDone) {
      CommUtils.msg('数据加载完成')
    }
    return hasLoadDone
  }

  clearPlayObjBMD(): void {
    this.playObjBMD = {}
  }

  clearPlyObjHMD(): void {
    this.playObjHMD = {}
  }

  removeTracks(trackIds?: string[]): void {
    trackIds = trackIds || Object.keys(this.playTrackItems)
    for (const trackId of trackIds) {
      const trackItem = this.playTrackItems[trackId]
      if (trackItem) {
        this.removePlayObjByItem(trackItem)
        document.querySelector(`#trackinfo_${trackId}`)?.remove()
        this.playTrackItems[trackId] = null
        delete this.playTrackItems[trackId]
      }
    }
    this._resetMinMaxTime()
    this.setPlayerDisplay(false)
    this.playStart(0, false)
  }

  removePlayObjByItem(trackItem: any): void {
    if (trackItem.playObj) {
      this._map.removeLayer(trackItem.playObj)
      trackItem.playObj = null
    }
    if (trackItem.playObjLabel) {
      this._map.removeLayer(trackItem.playObjLabel)
      trackItem.playObjLabel = null
    }
  }

  playStart(currentTime = 0, isAdd?: boolean, isSupple?: boolean): void {
    if (isSupple === undefined) isSupple = true
    if (currentTime) {
      this.currentTimePosition = Math.max(this.minTime, currentTime)
      this.currentTimePosition = Math.min(
        this.currentTimePosition,
        this.maxTime
      )
    } else {
      this.currentTimePosition = Math.max(
        this.currentTimePosition,
        this.minTime
      )
      this.currentTimePosition = Math.min(
        this.currentTimePosition,
        this.maxTime
      )
    }
    if (
      this.currentTimePosition >= this.maxTime ||
      this.currentTimePosition <= this.minTime
    ) {
      this.currentTimePosition = this.minTime
    }
    isAdd = isAdd === undefined ? false : isAdd
    if (!this.playState) {
      this.playState = true
      this._playByPosition(isAdd)
    }
    if (!isAdd && this.playBtn) {
      L.DomUtil.removeClass(this.playBtn, 'start')
      L.DomUtil.removeClass(this.playBtn, 'stop')
      L.DomUtil.addClass(this.playBtn, 'stop')
    }
  }

  playStop(): void {
    this.playState = false
    if (this.playBtn) {
      L.DomUtil.removeClass(this.playBtn, 'start')
      L.DomUtil.removeClass(this.playBtn, 'stop')
      L.DomUtil.addClass(this.playBtn, 'start')
    }
  }

  playStartOrStop(): boolean {
    if (this.playState) {
      this.playStop()
    } else {
      this.playStart()
    }
    return this.playState
  }

  setPlaySpeed(speed: number): number {
    const index = this.playSpeedList.indexOf(speed)
    if (index === -1) {
      speed = this.playSpeedList[0]
    }
    this.playSpeed = speed
    if (this.playSpeedSelectUL) {
      // 获取所有.playSpeed-select下的li元素并移除active类
      const listItems = document.querySelectorAll('.playSpeed-select li')
      listItems.forEach((item) => item.classList.remove('active'))

      // 为匹配playSpeed属性值为speed的li元素添加active类
      const activeItem = document.querySelector(
        `.playSpeed-select li[playSpeed="${speed}"]`
      )
      if (activeItem) {
        activeItem.classList.add('active')
      }
      this.playSpeedText.setAttribute('playSpeed', speed)
      this.playSpeedText.innerHTML = speed === 1 ? '倍速' : `${speed}X`
    }
    return this.playSpeed
  }

  setPlaySpeedList(speeds: number[], defaultSpeed: number): number[] {
    this.playSpeedList = speeds || this.playSpeedList
    defaultSpeed = defaultSpeed ? Number(defaultSpeed) : this.playSpeedList[0]
    if (defaultSpeed !== this.playSpeed) {
      this.setPlaySpeed(defaultSpeed)
    }
    if (this.playSpeedSelectUL) {
      this.playSpeedSelectUL.remove()
      this.playSpeedSelectUL = L.DomUtil.create(
        'ul',
        'playSpeed-select truckplayer-display-none',
        this.playerOptionDiv
      )
      this.playSpeedSelectlis = []
      let speedHtml: HTMLElement | null = null
      this.playSpeedList.forEach((item) => {
        this.playSpeed == item && 1 == this.playSpeed
          ? ((this.playSpeedText.innerHTML = '倍速'),
            this.playSpeedText.setAttribute('playSpeed', '1'))
          : this.playSpeed == item &&
            ((this.playSpeedText.innerHTML = `${item}X`),
            this.playSpeedText.setAttribute('playSpeed', `${item}`)),
          (speedHtml = L.DomUtil.create(
            'li',
            this.playSpeed == item ? 'active' : '',
            this.playSpeedSelectUL
          )).setAttribute('playSpeed', `${item}`),
          (speedHtml.innerHTML = `${item}X`),
          this.playSpeedSelectlis.push(speedHtml)
      })
      // 获取所有的li元素
      const playSpeedSelectListItems = document.querySelectorAll(
        '.playSpeed-select li'
      )

      // 为每个li元素添加点击事件监听器
      playSpeedSelectListItems.forEach((item) => {
        item.addEventListener('click', (event) => {
          // 获取当前点击的li元素的playSpeed属性值
          const playSpeed =
            (event.currentTarget as HTMLLIElement).getAttribute('playSpeed') ||
            0
          this.setPlaySpeed(playSpeed as any)
          this.playSpeedSelectUL.style.display = 'none'
        })
      })
    }
    return this.playSpeedList
  }

  getPlaySpeed(): number {
    return this.playSpeed
  }

  setPlayerDisplay(show?: boolean, isAdd?: boolean): void {
    if (!show) {
      show = this.maxTime - this.minTime > 0
    }
    this.playerDiv &&
      L.DomUtil.removeClass(this.playerDiv, 'truckplayer-display-none')
    this.playerDiv &&
      L.DomUtil.removeClass(this.playerDiv, 'truckplayer-display-block')
    if (show) {
      this.playerDiv &&
        L.DomUtil.addClass(this.playerDiv, 'truckplayer-display-block')
      this.playerTiao &&
        (this.playerTiaoW =
          this.playerTiao.offsetWidth - this.playerYuan.offsetWidth)
      this.playStart(0, isAdd)
    } else {
      this.playerDiv &&
        L.DomUtil.addClass(this.playerDiv, 'truckplayer-display-none')
    }
    if (isAdd === undefined) {
      isAdd = this.options.playObjLabelItems.includes('track')
    }
    if (this.trackInfo_leftBtn && this.trackInfo_rightBtn) {
      L.DomUtil.removeClass(this.trackInfo_leftBtn, 'truckplayer-display-none')
      L.DomUtil.removeClass(this.trackInfo_rightBtn, 'truckplayer-display-none')
      L.DomUtil.removeClass(this.trackInfo_leftBtn, 'truckplayer-display-block')
      L.DomUtil.removeClass(
        this.trackInfo_rightBtn,
        'truckplayer-display-block'
      )
      if (Object.keys(this.playTrackItems).length > this.trackInfoViewCount) {
        L.DomUtil.addClass(this.trackInfo_leftBtn, 'truckplayer-display-block')
        L.DomUtil.addClass(this.trackInfo_rightBtn, 'truckplayer-display-block')
      } else {
        L.DomUtil.addClass(this.trackInfo_leftBtn, 'truckplayer-display-none')
        L.DomUtil.addClass(this.trackInfo_rightBtn, 'truckplayer-display-none')
      }
    }
    if (this.shipListBtn) {
      document
        .querySelector('.playShipList')
        ?.classList.add('truckplayer-display-none')
    }
  }

  /**
   * 创建船舶图标
   * @param latlngs
   * @param options
   * @returns
   */
  _creatPlayObj(latlngs: L.LatLng[], options?: any): L.PolylineDecorator {
    const color = this.playObjBMD[`${options.mmsi}`] ? '#e539cf' : '#ffff66'
    const length = options.length || 0
    const width = options.width || 0
    const pathOptions: L.PathOptions = {
      fillOpacity: 1,
      stroke: true,
      weight: 1,
      color: '#222222',
      fill: true,
      fillColor: color,
    }
    if (options) {
      if (options.lineColor) pathOptions.color = options.lineColor
      if (options.color) pathOptions.fillColor = options.color
    }

    return L.polylineDecorator(latlngs as any, {
      patterns: [
        {
          offset: -30,
          symbol: trackShipSymbol({
            pixelSize: 24,
            headAngle: 40,
            pathOptions,
            ship: {
              length,
              width,
            },
            shipTemplaterThree: this.options.shipTemplaterThree,
            shipTemplaterZoom: this.options.shipTemplaterZoom,
          }),
        },
      ],
      zIndexOffset: 1000,
    })
  }

  /**
   * 跟随绘制船舶显示信息
   * @param latLng
   * @param ship
   * @param dataInfo
   * @param index
   * @returns
   */
  _creatOrUpdatePlayObjLable(
    latLng: L.LatLng,
    ship: any,
    dataInfo: any,
    index: number
  ): L.Marker {
    let labelContent = '' // 标签内容
    let playObjLabel = dataInfo.playObjLabel // 播放对象标签
    const additionalData = dataInfo.dataInfo[index] // 额外的数据信息
    ship = Object.assign({}, ship, additionalData)
    // 标签项
    for (const item of this.options.playObjLabelItems) {
      let value = ''
      switch (item.toLowerCase()) {
        case 'name':
          value =
            ship.custom_name || ship.cnname || ship.name || ship.shipName || ''
          break
        case 'mmsi':
          value = ship.mmsi || ship.MMSI || ship.Mmsi || ''
          break
        case 'sog':
          value = ship.sog || ''
          break
        case 'hdg':
          value = ship.hdg || ''
          break
        case 'cog':
          value = ship.cog || ''
          break
        default:
          value = ship[item] || ''
      }
      if (value) {
        const template = this._playObjLabelTemplater[item.toLowerCase()]
        if (template) {
          labelContent += template.replace('{value}', value)
        }
      }
    }
    // 如果存在标签，则更新位置和内容
    if (playObjLabel) {
      playObjLabel.setLatLng(latLng)
      playObjLabel._tooltip._container.innerHTML = labelContent
    } else {
      const markerOptions = {
        icon: L.icon({
          iconUrl:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAZCAYAAADTyxWqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ1dWlkOjY1RTYzOTA2ODZDRjExREJBNkUyRDg4N0NFQUNCNDA3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFENzY1MUQyODUzNzExRTU4RTQwRkQwODFEOUZEMEE3IiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFENzY1MUQxODUzNzExRTU4RTQwRkQwODFEOUZEMEE3IiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE1IChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MTk5NzA1OGEtZDI3OC00NDZkLWE4ODgtNGM4MGQ4YWI1NzNmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YzRkZmQxMGMtY2NlNS0xMTc4LWE5OGQtY2NkZmM5ODk5YWYwIi8+IDxkYzp0aXRsZT4gPHJkZjpBbHQ+IDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+Z2x5cGhpY29uczwvcmRmOmxpPiA8L3JkZjpBbHQ+IDwvZGM6dGl0bGU+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+bwCVTQAAARZJREFUeNqclQERwyAMRaEGhoRKmAQkVEIlIKESJgEJSNgcVELngClgcBd2LCWBkrt/t63JCwlLKkIIAiuaijJRe1RASr+tyecUVwHpqKMCwUo+moRBxnBR6wkGJ6JOYKMeRNlJdwzDpXlcRpEUQ48frFKez9mYC8LJ1/zQUX1ggLgtLj/460ELRLTGT1LKdOTSXqLfjuLzbUq9QQ6zGLVamQnYUaLCcRMwPyjH1nEOg76/qdtkb5SYFNsaI1f+36C/lvDV3ARc0ROP0zII8vnCcC/cAMxQK0hBpl6Qay3H5UJ5ioUBcOuA6eba7uyfqcY0xqW2WS0Z0zF/O3ozqSEYAGdotudASRICWIs77w4bZuf8vgIMAAI1tNMVERhgAAAAAElFTkSuQmCC',
          iconAnchor: new L.Point(5, 10),
          iconSize: [0, 0],
        }),
      }
      const marker = L.marker(latLng, markerOptions)
        .bindTooltip(labelContent, {
          direction: 'auto',
          offset: new L.Point(0, -30),
          opacity: 0.7,
          permanent: true,
          className: 'trackPlay_label_tooltip unvisiable',
        })
        .openTooltip()
        .off('click')
        .addTo(this._map)
      playObjLabel = marker
    }

    this.options.showPlayObjLable && this.setPlayObjLabelShow(true)
    return playObjLabel
  }

  setPlayObjLabelShow(show: boolean): void {
    this.options.showPlayObjLable = show
    if (show) {
      Array.from(document.querySelectorAll('.trackPlay_label:not(.unvisiable)'))
        .filter((label: any) =>
          label.parentElement.classList.contains('unvisiable')
        )
        .forEach((label: any) =>
          label.parentElement.classList.remove('unvisiable')
        )
    } else {
      document
        .querySelectorAll('.trackPlay_label_tooltip')
        .forEach((tooltip) => tooltip.classList.add('unvisiable'))
    }
  }

  setShipWithNoSignalShow(show: boolean): void {
    this.options.isVisiableWithNoSignal = show
  }

  setPlayObjLabelContent(items: string[]): void {
    this.setPlayObjLabelShow(false)
    this.options.playObjLabelItems = items
    document.querySelectorAll('.trackPlay_label').forEach((label) => {
      label.classList.add('unvisiable')
    })
    for (const item of items) {
      document
        .querySelectorAll(`.unvisiable.trackPlay_label_${item}`)
        .forEach((label) => {
          label.classList.remove('unvisiable')
        })
    }
    this.setPlayObjLabelShow(true)
  }

  _supplementLatLng(data: any): any {
    let isAdd = false
    let supplementData: any = null
    const trackId = data.trackId
    if (data.isAdd) {
      supplementData = this.playTrackItems[trackId]
    }
    if (!supplementData) {
      isAdd = true
      supplementData = {
        ship: null,
        minTime: null,
        maxTime: null,
        data: {},
        dataInfo: {},
        playObj: null,
      }
      supplementData.ship = data.ship
    }

    const points = data.data
    const numPoints = points.length || 0
    if (numPoints > 0) {
      // 假设 utc 是时间戳，需要转换为实际时间
      const firstUtc = points[0].utc
      const lastUtc = points[numPoints - 1].utc
      if (isAdd) {
        supplementData.minTime = 1000 * firstUtc // 转换为毫秒
        supplementData.maxTime = 1000 * lastUtc
      } else {
        supplementData.minTime = Math.min(
          supplementData.minTime,
          1000 * firstUtc
        )
        supplementData.maxTime = Math.max(
          supplementData.maxTime,
          1000 * lastUtc
        )
      }
      if (
        supplementData.minTime < 1000000000000 ||
        supplementData.maxTime < 1000000000000 ||
        supplementData.minTime > 2000000000000 ||
        supplementData.maxTime > 2000000000000
      ) {
        return console.error('时间戳非法!')
      }

      // 补充数据
      for (let i = 0; i < numPoints; i++) {
        const point = points[i]
        if (point.lon) point.lng = point.lon // 统一使用 lng
        if (point.lng) point.lon = point.lng // 统一使用 lat
        supplementData.dataInfo[1000 * point.utc] = point
        supplementData.data[1000 * point.utc] = L.latLng(point.lat, point.lng)
      }
    }
    return supplementData
  }

  // 基于位置的播放逻辑
  _playByPosition(isForcedPlay = false) {
    if (this.playState) {
      // 如果提供了有效的position参数，则使用它；否则根据播放速度增加当前时间位置
      if (!isForcedPlay) {
        this.currentTimePosition +=
          this.playSpeedOne * this.playSpeed * this.options.playFrequency
      }
      if (this.currentTimePosition > this.maxTime) {
        this.currentTimePosition = this.maxTime
        console.log('播放已结束！')
        this.playState = false
      } else {
        // 存储需要处理的轨迹ID列表
        const tracksToProcess = []
        // 遍历播放轨迹项
        for (const trackId in this.playTrackItems) {
          const trackData = this.playTrackItems[trackId].data
          if (trackData) {
            // 检查当前时间点是否存在轨迹数据
            if (this.currentTimePosition in trackData) {
              // 如果存在数据，直接使用
            } else {
              // 如果当前时间点没有数据，且不在轨迹的最小和最大时间范围内，则进行动态补点
              if (
                this.currentTimePosition < trackData.minTime ||
                this.currentTimePosition > trackData.maxTime
              ) {
                // 如果时间超出范围，不进行处理
              } else if (!this.isMousedown) {
                // 获取当前时间点附近的GPS轨迹数据，并进行动态补点
                const [prevGPS, nextGPS] = this._getNearGPSTracks(
                  trackId,
                  this.currentTimePosition
                )
                this._dongtaibudian(trackId, prevGPS, nextGPS)
              }
            }

            // 根据是否存在当前时间点的数据，决定是否需要添加或更新播放对象
            if (this.currentTimePosition in trackData) {
              if (this.playObjHMD[trackId]) {
                // 如果存在播放对象，移除并处理历史轨迹
                this.removePlayObjByItem(trackData)
                this._removeShipHistoryTrack(trackId)
              } else {
                tracksToProcess.push(trackId)
              }
            } else if (this.playObjHMD[trackId]) {
              // 如果不存在数据，但存在播放对象，移除并处理历史轨迹
              this.removePlayObjByItem(trackData)
              this._removeShipHistoryTrack(trackId)
            } else if (
              this.playObjBMD[trackId] ||
              this.options.isVisiableWithNoSignal ||
              this.options.isVisiableOutOfBounds
            ) {
              tracksToProcess.push(trackId)
            }
          }
        }
        // 遍历有效船只数组，更新播放对象和历史轨迹
        for (const shipId of tracksToProcess) {
          const currentShipItem = this.playTrackItems[shipId]
          const currentGPSTime = this._getPreviousGPSTimeByCTime(
            shipId,
            this.currentTimePosition
          )
          let currentPoint = currentShipItem.data[this.currentTimePosition]
          let previousPoint =
            currentShipItem.data[
              this.currentTimePosition - this.options.playFrequency
            ]

          if (!previousPoint) continue
          // 如果当前点或前一个点存在，更新播放对象和标签
          if (
            currentPoint ||
            (this.options.isVisiableWithNoSignal &&
              (this.options.isVisiableOutOfBounds ||
                this.currentTimePosition <= currentShipItem.maxTime) &&
              (currentPoint = currentShipItem.dataInfo[currentGPSTime]))
          ) {
            currentPoint = CanvasShipUtils.GPSEncryptByMapToLatLng(
              currentPoint,
              this._map
            )
            previousPoint = CanvasShipUtils.GPSEncryptByMapToLatLng(
              previousPoint,
              this._map
            )
            if (!currentShipItem.playObj) {
              this.playTrackItems[shipId].playObj = this._creatPlayObj(
                [
                  [previousPoint.lat, previousPoint.lng],
                  [currentPoint.lat, currentPoint.lng],
                ] as any,
                currentShipItem.ship
              )
              this.playTrackItems[shipId].playObj.addTo(this._map)
            }

            const trackPoints = [
              [previousPoint.lat, previousPoint.lng],
              [currentPoint.lat, currentPoint.lng],
            ]
            this._setItem_HDG(shipId, currentGPSTime)
            // if (currentGPSTime) {
            // }

            this.playTrackItems[shipId].playObj.setPaths(trackPoints)
            this.playTrackItems[shipId].playObjLabel =
              this._creatOrUpdatePlayObjLable(
                trackPoints[1] as any,
                this.currentTimePosition,
                currentShipItem,
                currentGPSTime
              )

            if (currentGPSTime) {
              this._updateTrackInfo(shipId, currentGPSTime)
              if (this.options.playGPSCallBack) {
                setTimeout(() => {
                  this.options.playGPSCallBack &&
                    this.options.playGPSCallBack(
                      this.playTrackItems[shipId].dataInfo[currentGPSTime],
                      this.playTrackItems[shipId],
                      currentGPSTime
                    )
                }, 10) // Timeout duration in milliseconds
              }
              if (this.options.isVisiableShipTrack) {
                this._drawShipHistoryTrack(shipId, this.currentTimePosition)
              }
            }
          } else {
            // 如果当前点不存在，移除播放对象和历史轨迹
            if (this.playTrackItems[shipId].playObj) {
              this.removePlayObjByItem(this.playTrackItems[shipId])
              this._removeShipHistoryTrack(shipId)
            }
          }
        }

        // 更新播放器位置和回调
        this._setPlayerPosition()

        // 如果存在播放回调，执行回调
        if (this.options.playCallBack) {
          setTimeout(() => {
            this.options.playCallBack &&
              this.options.playCallBack(
                this.currentTimePosition,
                this._getCurrentTimeShipInfo(this.currentTimePosition)
              )
          })
        }

        // 如果播放状态为真，且没有提供position参数，则继续播放
        if (this.playState && !isForcedPlay) {
          setTimeout(() => {
            this._playByPosition()
          }, this.options.playFrequency)
        } else {
          this.playState = false
        }
      }
    }
  }

  /**
   * 补充间隔
   * @param trackId
   * @param startGPS
   * @param endGPS
   */
  _dongtaibudian(trackId: string, startGPS: any, endGPS: any): void {
    if (startGPS && endGPS) {
      if (
        this.maxSupplementPointInterval > 0 &&
        endGPS.utc - startGPS.utc > this.maxSupplementPointInterval
      ) {
        // 间隔超过最大补充点间隔，不进行补充
      } else {
        // 计算补点的时间间隔和坐标变化率
        const timeDiff =
          (1000 * (endGPS.utc - startGPS.utc)) / this.options.playFrequency
        const latChangeRate = (endGPS.lat - startGPS.lat) / timeDiff
        const lngChangeRate = (endGPS.lng - startGPS.lng) / timeDiff
        // 初始化补点的中间变量
        for (let i = 0; i < timeDiff; i++) {
          const currentTime =
            startGPS.utc * 1000 + i * this.options.playFrequency
          const newLat = startGPS.lat + i * latChangeRate
          const newLng = startGPS.lng + i * lngChangeRate
          const newLatLng = L.latLng(newLat, newLng)
          // 将补点坐标存入对应trackId的数据中
          this.playTrackItems[trackId].data[currentTime] = newLatLng
        }
      }
    }
  }

  // 根据当前时间获取最近的GPS时间
  _getPreviousGPSTimeByCTime(trackId: string, currentTime: number): number {
    if (!this.playTrackItems[trackId]) {
      console.log(`trackId is null=${trackId}`)
      return 0
    }
    const dataInfo = this.playTrackItems[trackId].dataInfo

    if (currentTime && dataInfo) {
      if (currentTime in dataInfo) return currentTime
      const keys = Object.keys(dataInfo)
      for (let i = 0; i < keys.length; i++) {
        const keyTime = Number(keys[i])
        if (keyTime > currentTime && 0 == keyTime) return 0
        if (keyTime > currentTime) return Number(keys[i - 1])
      }
    }
    return 0
  }
  // 根据当前时间获取最近的GPS轨迹点
  _getNearGPSTracks(trackId: string, currentTime: number) {
    const result = [null, null]
    if (this.playTrackItems[trackId]) {
      const dataInfo = this.playTrackItems[trackId].dataInfo
      const keys = Object.keys(dataInfo)
      for (let i = 0; i < keys.length - 1; i++) {
        const prevGPS = dataInfo[keys[i]]
        const nextGPS = dataInfo[keys[i + 1]]
        if (
          currentTime > prevGPS.utc * 1000 &&
          currentTime < nextGPS.utc * 1000
        ) {
          result[0] = prevGPS
          result[1] = nextGPS
          break
        }
      }
    } else {
      console.log(`trackId is null=${trackId}`)
    }
    return result
  }

  // 获取当前时间的船舶历史轨迹
  _getCurrentTimeShipHistoryTrack(
    trackId: string,
    currentTime: number
  ): L.LatLng[] {
    let trackData: L.LatLng[] = []
    if (this.playTrackItems[trackId]) {
      const dataInfo = this.playTrackItems[trackId].dataInfo
      const keys = Object.keys(dataInfo)
      if (keys.length > 0 && Number(keys[0]) < currentTime) {
        for (
          let i = 0;
          i < keys.length && Number(keys[i]) <= currentTime;
          i++
        ) {
          const latLng = CanvasShipUtils.GPSEncryptByMapToLatLng(
            dataInfo[keys[i]],
            this._map
          )
          if (
            this.options.shipTrackMaxInterval > 0 &&
            trackData.length > 0 &&
            Number(keys[i]) - Number(keys[i - 1]) >
              this.options.shipTrackMaxInterval * 1000
          ) {
            trackData = [] // 重置轨迹数组
          }
          trackData.push(latLng)
        }
      }
    }
    this.shipHistoryTrackData[trackId] = trackData
    return trackData
  }

  // 获取当前时间的船舶信息
  _getCurrentTimeShipInfo(currentTime: number): any {
    const shipInfo: any = {}
    for (const trackId in this.playTrackItems) {
      const trackItem = this.playTrackItems[trackId]
      const currentGPS = trackItem.data[currentTime]
      const previousTime = this._getPreviousGPSTimeByCTime(
        trackItem.trackid,
        currentTime
      )
      const previousGPS = previousTime ? trackItem.dataInfo[previousTime] : null
      const shipData = Object.assign({}, trackItem.ship, {
        lat: currentGPS ? currentGPS.lat : null,
        lng: currentGPS ? currentGPS.lng : null,
        utc: currentTime,
        ...(previousGPS || {}),
      })
      shipInfo[trackId] = shipData
    }
    return shipInfo
  }
  // 设置船舶历史轨迹的显示
  setShipHistoryTrackShow(show: boolean): void {
    this.options.isVisiableShipTrack = show
    if (show) {
      // 如果需要开始播放或者当前不在播放状态
      if (!this.playSate) {
        this.playStart(0, false)
      }
    } else {
      this._removeShipHistoryTrack()
    }
  }

  // 设置船舶历史轨迹的样式
  setShipHistoryTrackStyle(style: any) {
    this.shipHistoryTrackStyle = Object.assign(
      {},
      this.shipHistoryTrackStyle,
      style
    )
    for (const trackId in this.shipHistoryTrackLine) {
      this.shipHistoryTrackLine[trackId].setStyle(this.shipHistoryTrackStyle)
    }
    return this.shipHistoryTrackStyle
  }

  // 绘制船舶历史轨迹
  _drawShipHistoryTrack(trackId: string, currentTime: number): void {
    const currentTrack = this._getCurrentTimeShipHistoryTrack(
      trackId,
      currentTime
    )
    const currentPos = this.playTrackItems[trackId].data[currentTime]
    if (currentPos) {
      const latLng = CanvasShipUtils.GPSEncryptByMapToLatLng(
        currentPos,
        this._map
      )
      currentTrack.push(latLng)
    }
    if (currentTrack.length >= 2) {
      if (this.shipHistoryTrackLine[trackId]) {
        this.shipHistoryTrackLine[trackId].setLatLngs(currentTrack)
      } else {
        this.shipHistoryTrackLine[trackId] = L.polyline(
          currentTrack,
          this.shipHistoryTrackStyle
        ).addTo(this._map)
      }
    }
  }

  // 移除船舶历史轨迹
  _removeShipHistoryTrack(trackId?: string): void {
    if (trackId) {
      if (this.shipHistoryTrackLine[trackId]) {
        this._map.removeLayer(this.shipHistoryTrackLine[trackId])
        delete this.shipHistoryTrackLine[trackId]
      }
    } else {
      for (const id in this.shipHistoryTrackLine) {
        this._removeShipHistoryTrack(id)
      }
    }
  }

  // 重置最小最大时间
  _resetMinMaxTime(
    minTime?: number,
    maxTime?: number,
    resetCurrentTime?: boolean
  ): void {
    this.minTime = 0
    this.maxTime = 0
    if (this.playerCtime) this.playerCtime.innerHTML = ''
    if (this.playerEtime) this.playerEtime.innerHTML = ''
    if (minTime && maxTime) {
      this.minTime = minTime
      this.maxTime = maxTime
    } else {
      if (Object.keys(this.playTrackItems).length > 0) {
        for (const item in this.playTrackItems)
          0 == this.minTime
            ? (this.minTime = this.playTrackItems[item].minTime)
            : (this.minTime = Math.min(
                this.minTime,
                this.playTrackItems[item].minTime
              )),
            0 == this.maxTime
              ? (this.maxTime = this.playTrackItems[item].maxTime)
              : (this.maxTime = Math.max(
                  this.maxTime,
                  this.playTrackItems[item].maxTime
                ))
      }
    }
    if (resetCurrentTime) {
      this.currentTimePosition = this.minTime
    }
    if (this.minTime !== 0 && this.playerCtime) {
      this.playerCtime.innerHTML = CanvasShipUtils.dataFormat(
        new Date(this.currentTimePosition),
        'YYYY-MM-DD HH:mm:ss'
      )
    }
    if (this.maxTime !== 0 && this.playerEtime) {
      this.playerEtime.innerHTML = `/${CanvasShipUtils.dataFormat(
        new Date(this.maxTime),
        'YYYY-MM-DD HH:mm:ss'
      )}`
    }
  }
  // 创建播放器的 HTML 元素
  _createPlayerHtml(): void {
    this.playerDiv = L.DomUtil.create(
      'div',
      'truckplayer truckplayer-display-none',
      this._map._container
    )
    L.DomEvent.disableClickPropagation(this.playerDiv)
    L.DomEvent.disableScrollPropagation(this.playerDiv)

    this.playerTitleDiv = L.DomUtil.create(
      'div',
      'truckplayer-title float-left',
      this.playerDiv
    )
    this.playerTitleOption = L.DomUtil.create(
      'div',
      'title-option float-left',
      this.playerTitleDiv
    )
    this.playerTitleOption.innerHTML = this._getPlayOptionHtml()

    this.playerTitleBtn = L.DomUtil.create(
      'div',
      'title-btn float-right',
      this.playerTitleDiv
    )
    // 全屏显示控件
    // this.playerTitleFullScreen = L.DomUtil.create(
    //   'div',
    //   'title-fullScreen float-right',
    //   this.playerTitleDiv
    // )

    this.playerTiao = L.DomUtil.create(
      'div',
      'truckplayer-tiao float-left',
      this.playerDiv
    )
    this.playerYuan = L.DomUtil.create(
      'div',
      'truckplayer-yuan',
      this.playerTiao
    )
    this.playerJindu = L.DomUtil.create(
      'div',
      'truckplayer-jindu',
      this.playerTiao
    )

    this.playerOptionDiv = L.DomUtil.create(
      'div',
      'truckplayer-option float-left',
      this.playerDiv
    )
    this.playBtn = L.DomUtil.create(
      'button',
      'truckplayer-play start float-left',
      this.playerOptionDiv
    )

    this.playerTimeDiv = L.DomUtil.create(
      'div',
      'truckplayer-time float-left',
      this.playerOptionDiv
    )
    this.playerCtime = L.DomUtil.create(
      'div',
      'truckplayer-ctime float-left unselectde',
      this.playerTimeDiv
    )
    this.playerCtime.title = '当前时间'

    this.playerEtime = L.DomUtil.create(
      'div',
      'truckplayer-etime float-left unselectde',
      this.playerTimeDiv
    )
    this.playerEtime.title = '截止时间'

    this.playSpeedDiv = L.DomUtil.create(
      'div',
      'playSpeed float-right',
      this.playerOptionDiv
    )
    this.playSpeedDiv.title = '倍速'

    this.playSpeedText = L.DomUtil.create(
      'div',
      'playSpeed-txt float-left unselectde',
      this.playSpeedDiv
    )
    this.playSpeedImg = L.DomUtil.create(
      'div',
      'playSpeed-img up float-left',
      this.playSpeedDiv
    )
    this.playSpeedSelectUL = L.DomUtil.create(
      'ul',
      'playSpeed-select truckplayer-display-none',
      this.playerOptionDiv
    )
    this.playSpeedSelectlis = []

    this.playSpeedList.forEach((speed) => {
      const li = L.DomUtil.create(
        'li',
        this.playSpeed === speed ? 'active' : '',
        this.playSpeedSelectUL
      )
      li.setAttribute('playSpeed', speed.toString())
      li.innerHTML = `${speed}X`
      this.playSpeedSelectlis.push(li)
    })

    this.playSpeedText.innerHTML =
      this.playSpeed === 1 ? '倍速' : `${this.playSpeed}X`

    this.shipListBtn = L.DomUtil.create(
      'div',
      'trackinfo-sh-btn playSpeed float-right',
      this.playerOptionDiv
    )
    this.shipListBtn.title = '船舶列表'
    this.shipListBtnText = L.DomUtil.create(
      'div',
      'unselectde',
      this.shipListBtn
    )
    this.shipListBtnText.innerHTML = '船舶列表'

    // 创建轨迹信息显示区域
    if (this.trackInfoSHBtn) {
      this.trackInfoDiv = L.DomUtil.create(
        'div',
        'playTrackInfo truckplayer-display-none',
        this.playerDiv
      )
      this.trackInfo_leftBtn = L.DomUtil.create(
        'div',
        'btn left-btn float-left truckplayer-display-none',
        this.trackInfoDiv
      )
      this.trackInfo_center = L.DomUtil.create(
        'div',
        'center-tracks float-left',
        this.trackInfoDiv
      )
      this.trackInfo_rightBtn = L.DomUtil.create(
        'div',
        'btn right-btn float-left truckplayer-display-none',
        this.trackInfoDiv
      )
      L.DomEvent.disableClickPropagation(this.trackInfoDiv)
      this.trackInfoViewCount = 2
      this.trackInfoCIndex = 0
    }

    // 创建船舶列表显示区域
    if (this.shipListBtn) {
      this.shipListDiv = L.DomUtil.create(
        'div',
        'playShipList truckplayer-display-none',
        this._map._container
      )
      this.shipList_title = L.DomUtil.create(
        'div',
        'playShipListTitle',
        this.shipListDiv
      )
      this.shipList_content = L.DomUtil.create(
        'div',
        'playShipListContent',
        this.shipListDiv
      )
      this.shipList_foot = L.DomUtil.create(
        'div',
        'playShipListFoot',
        this.shipListDiv
      )
      L.DomEvent.disableClickPropagation(this.shipListDiv)
      L.DomEvent.disableScrollPropagation(this.shipListDiv)
      new L.Draggable(this.shipListDiv, this.shipList_title).enable()
      this.shipList_title.innerHTML = `
                <span class="titleText">船舶列表</span>
                <div class="titleBtn">
                    <div style="position: absolute;">
                        <input type="text" placeholder="搜索船舶"/>
                        <span class="search"></span>
                    </div>
                    <span class="clear"></span>
                    <span class="titleClose"></span>
                </div>
            `
      this.shipList_content.innerHTML = this._getShipListHtml()
      this.shipList_foot.innerHTML = `<input type="button" value="导出"/>`
    }

    // 初始化播放器的其他属性
    this.playerTiaoW = this.playerTiao.offsetWidth - this.playerYuan.offsetWidth
    this.playerPercentage = 0
    this.playerMinValue = 0
    this.playerMaxValue = 100

    // 初始化播放器行为
    this._buildPlayer()
    if (this.draggable) {
      const wasEnabled = this.draggable._enabled
      this.draggable = new L.Draggable(this.playerDiv, this.playerTitleDiv)
      wasEnabled ? this.draggable.enable() : this.draggable.disable()
    } else {
      this.draggable = new L.Draggable(this.playerDiv, this.playerTitleDiv)
      this.draggable.enable()
    }
  }
  // 生成播放器选项的 HTML
  _getPlayOptionHtml(): string {
    const playObjPlayerItems = this.options.playObjPlayerItems
    const playObjLabelItems = this.options.playObjLabelItems
    let html = ''
    for (const item of playObjPlayerItems) {
      const isChecked = playObjLabelItems.includes(item)
      html += `
                <li el-data="${item}">
                    <input type="checkbox" ${
                      isChecked ? 'checked="checked"' : ''
                    } />
                    ${item}
                </li>
            `
    }
    return `<ul>${html}</ul>`
  }

  // 生成船舶列表的 HTML
  _getShipListHtml(): string {
    const shipListLength = Object.keys(this.playTrackItems).length
    // $(this.shipList_title).find('.titleText').text(`船舶列表(${shipListLength})`)
    if (this.shipList_title && this.shipList_title.querySelector) {
      const titleElement = this.shipList_title.querySelector('.titleText')
      if (titleElement) {
        titleElement.textContent = `船舶列表(${shipListLength})`
      }
    }

    const shipListHtml = `
            <div class="contentTitle">
                <table cellspacing="0">
                    <tr>
                        <td class="shipList_td1">序号</td>
                        <td class="shipList_td2">船名</td>
                        <td class="shipList_td3">MMSI</td>
                        <td class="shipList_td4">船舶类型</td>
                        <td class="shipList_td5">长 x 宽</td>
                        <td class="shipList_td6">进入时间</td>
                        <td class="shipList_td7">离开时间</td>
                        <td class="shipList_td8">操作<span></span></td>
                    </tr>
                </table>
            </div>
        `

    let shipListContentHtml = ''
    let index = 1
    for (const trackId in this.playTrackItems) {
      const trackItem = this.playTrackItems[trackId]
      const ship = trackItem.ship
      const shipName = ship.shipname || ship.name || ''
      const mmsi = ship.mmsi || ship.shipid
      const shipTypeCN = CanvasShipUtils.getShipTypeCN(ship.type) || ''
      const dimensions =
        ship.length && ship.width ? `${ship.length}*${ship.width}` : '--'
      const entryTime = CommUtils.dataFormat(trackItem.minTime / 1000) || ''
      const leaveTime = CommUtils.dataFormat(trackItem.maxTime / 1000) || ''

      shipListContentHtml += `
                <tr el-trackID="${trackId}" el-data="${shipName.toLowerCase()}-|--|-${mmsi}">
                    <td class="shipList_td1">${index++}</td>
                    <td class="shipList_td2" title="${shipName}">${shipName}</td>
                    <td class="shipList_td3" title="${mmsi}">${mmsi}</td>
                    <td class="shipList_td4" title="${shipTypeCN}">${shipTypeCN}</td>
                    <td class="shipList_td5" title="${dimensions}">${dimensions}</td>
                    <td class="shipList_td6" title="${entryTime}">${entryTime}</td>
                    <td class="shipList_td7" title="${leaveTime}">${leaveTime}</td>
                    <td class="shipList_td8"><span></span></td>
                </tr>
            `
    }

    return `${shipListHtml}<div class="contentContent"><table cellspacing="0">${shipListContentHtml}</table></div>`
  }

  // 更新船舶列表
  _updateShipList(): void {
    if (this.shipList_content) {
      this.shipList_content.innerHTML = this._getShipListHtml()
    }
  }
  // 轨迹信息轮播控制
  _playTrackInfoCarousel(increment = 0): void {
    const trackCount = Object.keys(this.playTrackItems).length
    if (trackCount > 0) {
      increment = increment || 0
      increment = Math.round(increment)
      this.trackInfoCIndex += increment
      const indices = []
      for (let i = 0; i < this.trackInfoViewCount; i++) {
        let index = this.trackInfoCIndex + i
        if (index >= trackCount || index < 0) {
          index = Math.round(index % trackCount)
        }
        indices.push(Math.abs(index))
      }
      this.trackInfoCIndex > trackCount &&
        (this.trackInfoCIndex = Math.round(this.trackInfoCIndex % trackCount))
      this._addTrackInfo(indices)
    }
  }

  // 添加轨迹信息
  _addTrackInfo(indices: number[]): void {
    if (this.trackInfoCenter) {
      const trackKeys = Object.keys(this.playTrackItems)
      this.trackInfoCenter.innerHTML = ''
      for (const index of indices) {
        if (index >= 0 && index < trackKeys.length) {
          this._createTrackHtml(trackKeys[index])
          this._updateTrackInfo(trackKeys[index])
        }
      }
    }
  }

  // 创建轨迹信息的 HTML
  _createTrackHtml(trackId: string): void {
    const trackDiv = L.DomUtil.create(
      'div',
      'track float-left',
      this.trackInfoCenter
    )
    trackDiv.id = `trackinfo_${trackId}`

    const createInfoLine = (name: string, valueId: string) => {
      const infoLineDiv = L.DomUtil.create(
        'div',
        'info-line float-left',
        trackDiv
      )
      const nameDiv = L.DomUtil.create('div', 'info-name', infoLineDiv)
      nameDiv.innerHTML = `${name}：`
      const valueDiv = L.DomUtil.create('div', 'info-value', infoLineDiv)
      valueDiv.id = valueId
    }

    createInfoLine('船名', `trackinfo_name_${trackId}`)
    createInfoLine('MMSI', `trackinfo_mmsi_${trackId}`)
    createInfoLine('船首向', `trackinfo_hdg_${trackId}`)
    createInfoLine('速度', `trackinfo_sog_${trackId}`)
    createInfoLine('航迹向', `trackinfo_cog_${trackId}`)
    createInfoLine('纬度', `trackinfo_lat_${trackId}`)
    createInfoLine('经度', `trackinfo_lng_${trackId}`)
    createInfoLine('状态', `trackinfo_status_${trackId}`)
    createInfoLine('更新时间', `trackinfo_time_${trackId}`)
  }

  // 设置轨迹的 HDG（航向）
  _setItem_HDG(trackId: string, time: number): void {
    const dataInfo = this.playTrackItems[trackId].dataInfo
    if (dataInfo) {
      const symbolFactory =
        this.playTrackItems[trackId].playObj._patterns[0].symbolFactory
      symbolFactory.hdg = dataInfo[time].hdg
    }
  }

  // 更新轨迹信息
  _updateTrackInfo(trackId: string, time = 0): void {
    const shipInfo = this.playTrackItems[trackId]?.ship
    let currentData: any = null
    if (shipInfo && this.playTrackItems[trackId].dataInfo) {
      const dataInfo = this.playTrackItems[trackId].dataInfo
      const keys = Object.keys(dataInfo)
      if (keys.length > 0) {
        if (!time) {
          time = this._getPreviousGPSTimeByCTime(
            trackId,
            this.currentTimePosition
          )
        }
        currentData = dataInfo[time]
      }
    }

    if (shipInfo) {
      const setHtmlValue = (id: string, value: string) => {
        const trackinfoKey = document.querySelector(`#${id}`)
        if (trackinfoKey) trackinfoKey.innerHTML = value
      }
      // 更新船只名称和MMSI
      setHtmlValue(`trackinfo_name_${trackId}`, shipInfo.name || '')
      setHtmlValue(`trackinfo_mmsi_${trackId}`, shipInfo.mmsi || '')

      if (currentData) {
        // 更新当前轨迹点的详细信息
        setHtmlValue(`trackinfo_hdg_${trackId}`, `${currentData.hdg || ''}度`)
        setHtmlValue(`trackinfo_sog_${trackId}`, `${currentData.sog || ''}节`)
        setHtmlValue(`trackinfo_cog_${trackId}`, `${currentData.cog || ''}度`)
        setHtmlValue(
          `trackinfo_lat_${trackId}`,
          CanvasShipUtils.latFormatter(currentData.lat)
        )
        setHtmlValue(
          `trackinfo_lng_${trackId}`,
          CanvasShipUtils.latFormatter(currentData.lng)
        )
        // 更新状态和时间
        const status =
          currentData.navistatus === null ? -1 : currentData.navistatus
        setHtmlValue(
          `trackinfo_status_${trackId}`,
          CanvasShipUtils.getDisValue(status, 'naviStatus', 'zh_CN')
        )

        setHtmlValue(
          `trackinfo_time_${trackId}`,
          CanvasShipUtils.dataFormat(new Date(time), 'YYYY-MM-DD HH:mm:ss')
        )
      }
    }
  }

  // 构建播放器
  _buildPlayer(): void {
    const _body = document.body
    this.isMousedown = false

    // 播放按钮点击事件
    if (this.playBtn) {
      this.playBtn.onclick = (): void => {
        if (
          this.playTrackItems &&
          Object.keys(this.playTrackItems).length > 0
        ) {
          this.playStartOrStop()
        }
      }
    }

    // 轨迹圆圈鼠标按下事件
    this.playerYuan.onmousedown = (): void => {
      if (
        this._checkLoadDataStatus() &&
        this.playTrackItems &&
        Object.keys(this.playTrackItems).length > 0
      ) {
        this.isMousedown = true
        _body.onmousemove = (mouseEvent): void => {
          this._setYuanPosition(mouseEvent)
        }
        if (this.playerDiv)
          this.playerDiv.onmouseleave = (): void => {
            if (this.isMousedown) {
              this.isMousedown = false
            }
          }
      }
    }

    // 鼠标弹起事件
    _body.onmouseup = (): void => {
      if (this.playTrackItems && Object.keys(this.playTrackItems).length > 0) {
        this.isMousedown = false
      }
    }

    // 轨迹条点击事件
    if (this.playerTiao) {
      this.playerTiao.onclick = (event): void => {
        if (this._checkLoadDataStatus()) {
          this.isMousedown = true
          this._setYuanPosition(event)
          this.isMousedown = false
        }
      }
    }

    // 播放速度按钮点击事件
    if (this.playSpeedDiv)
      this.playSpeedDiv.onclick = (): void => {
        if (this._checkLoadDataStatus()) {
          // $(this.playSpeedSelectUL).toggle(0, null)
          const playSpeedSelectULDisplay = this.playSpeedSelectUL.style.display
          if (
            playSpeedSelectULDisplay === 'none' ||
            playSpeedSelectULDisplay === ''
          ) {
            this.playSpeedSelectUL.style.display = 'block'
          } else {
            this.playSpeedSelectUL.style.display = 'none'
          }
        }
      }

    // 播放速度选择列表项点击事件
    const speedListItems = document.querySelectorAll('.playSpeed-select li')
    speedListItems.forEach((item) => {
      item.addEventListener('click', (speedClickEvent) => {
        if (this._checkLoadDataStatus()) {
          const playSpeed =
            (speedClickEvent.currentTarget as HTMLLIElement).getAttribute(
              'playSpeed'
            ) || 0
          this.setPlaySpeed(Number(playSpeed))
          this.playSpeedSelectUL.style.display = 'none'
        }
      })
    })

    // 播放器标题选项点击事件
    if (this.playerTitleOption) {
      const optionListItems = Array.from(
        this.playerTitleOption.querySelectorAll('li')
      )
      optionListItems.forEach((item) => {
        item.addEventListener('click', (optionClickEvent: any) => {
          const targetLi = optionClickEvent.currentTarget as any
          if (!targetLi) {
            return
          }
          const inputElement = targetLi.querySelector('input')
          const isChecked = inputElement.checked

          if (optionClickEvent.target.nodeName !== 'INPUT') {
            inputElement.checked = !isChecked
          }

          const dataAttr = targetLi.getAttribute('el-data')

          switch (dataAttr) {
            case 'area':
              break
            case 'track':
              this.setShipHistoryTrackShow(isChecked)
              break
            default:
              // 获取勾选的显示项
              // eslint-disable-next-line no-case-declarations
              const checkedList = Array.from(
                targetLi.parentNode.querySelectorAll('input:checked')
              )
              // eslint-disable-next-line no-case-declarations
              const datas = checkedList
                .filter((item: any) => {
                  return item.parentNode.getAttribute('el-data') !== 'area'
                })
                .map((item: any) => item.parentNode.getAttribute('el-data'))

              this.setPlayObjLabelContent(datas)
          }

          if (typeof this.options.labelOptionCallback === 'function') {
            this.options.labelOptionCallback(dataAttr, isChecked)
          }
        })
      })
    }

    // 全屏按钮点击事件
    if (this.playerTitleFullScreen)
      this.playerTitleFullScreen.onclick = (): void => {
        this.setFullScreen()
        if (this.options.fullScreenCallback) {
          this.options.fullScreenCallback()
        }
      }

    // 关闭按钮点击事件
    if (this.playerTitleBtn)
      this.playerTitleBtn.onclick = (): void => {
        this.closeTrackPlay()
      }

    // 轨迹信息左右切换按钮点击事件
    if (this.trackInfoSHBtn) {
      this.trackInfoSHBtn.onclick = (): void => {
        if (this._checkLoadDataStatus()) {
          const { x, y } = CommUtils.getElementPos(this._map._container)
          if (this.trackInfoDiv) {
            this.trackInfoDiv.style.left = `${50 + x}px`
            this.trackInfoDiv.style.top = `${100 + y}px`
            this.trackInfoDiv.style.display = 'none'
          }
          this._playTrackInfoCarousel()
        }
      }
    }

    if (this.trackInfoSHBtn) {
      // 轨迹信息左按钮点击事件
      this.trackInfo_leftBtn.onclick = (): void => {
        this._playTrackInfoCarousel(-1)
      }

      // 轨迹信息右按钮点击事件
      this.trackInfo_rightBtn.onclick = (): void => {
        this._playTrackInfoCarousel(1)
      }
    }

    // 船舶列表按钮点击事件
    if (this.shipListBtn) {
      this.shipListBtn.onclick = (): void => {
        if (this._checkLoadDataStatus() && this.shipListDiv) {
          const shipListDisplay = this.shipListDiv.style.display
          if (!shipListDisplay || shipListDisplay === 'none') {
            this.shipListDiv.classList.remove('truckplayer-display-none')
            this._updateShipList()
          } else {
            this.shipListDiv.classList.add('truckplayer-display-none')
          }
        }
      }
    }

    // 船舶列表标题关闭按钮点击事件
    if (this.shipList_title) {
      // 获取titleClose元素
      const titleCloseElements =
        this.shipList_title.querySelectorAll('.titleClose')

      // 为每个.titleClose元素添加点击事件监听器
      titleCloseElements.forEach((titleCloseElement) => {
        titleCloseElement.addEventListener('click', () => {
          // 当点击事件触发时，给shipListDiv元素添加truckplayer-display-none类
          this.shipListDiv &&
            this.shipListDiv.classList.add('truckplayer-display-none')
        })
      })
    }

    // 船舶列表标题按钮输入事件
    if (this.shipList_title) {
      const titleBtnInputs =
        this.shipList_title.querySelectorAll('.titleBtn input')

      // 为每个输入元素添加input事件监听器
      titleBtnInputs.forEach((inputElement) => {
        inputElement.addEventListener('input', (event: any) => {
          const inputValue = event.target.value.toLowerCase().trim()
          if (this.shipList_content) {
            const contentTrs =
              this.shipList_content.querySelectorAll('.contentContent tr')

            // 首先给所有内容行添加'unvisiable'类
            contentTrs.forEach((tr) => tr.classList.add('unvisiable'))

            if (inputValue === '') {
              // 如果输入为空，移除所有'unvisiable'类
              contentTrs.forEach((tr) => tr.classList.remove('unvisiable'))
            } else {
              // 否则，根据输入值筛选并移除匹配项的'unvisiable'类
              const matchingTrs = Array.from(contentTrs).filter((tr: any) =>
                tr.getAttribute('el-data').includes(inputValue)
              )
              matchingTrs.forEach((matchingTr) =>
                matchingTr.classList.remove('unvisiable')
              )
            }
          }
        })
      })

      // 船舶列表标题按钮清除点击事件
      const clearButtons = this.shipList_title.querySelectorAll(
        '.titleBtn div.clear'
      )

      // 为每个清除按钮添加点击事件监听器
      clearButtons.forEach((button) => {
        button.addEventListener('click', () => {
          // 清空标题按钮中的输入值
          if (this.shipList_title) {
            const inputElement = this.shipList_title.querySelector(
              '.titleBtn input'
            ) as any
            if (inputElement) {
              inputElement.value = ''
            }
          }

          // 移除所有'tr'元素的'unvisiable'类
          if (this.shipList_content) {
            const contentRows =
              this.shipList_content.querySelectorAll('.contentContent tr')
            contentRows.forEach((row) => row.classList.remove('unvisiable'))
          }
        })
      })
    }

    // 辅助函数，检查元素是否有指定类
    const hasClass = (element: Element, className: string) => {
      return ` ${element.className} `.includes(` ${className} `)
    }

    // 辅助函数，为元素添加类
    const addClass = (elements: Element[], className: string) => {
      elements.forEach((element) => {
        if (!hasClass(element, className)) {
          element.className += ` ${className}`
        }
      })
    }

    // 辅助函数，为元素移除类
    const removeClass = (elements: Element[], className: string) => {
      elements.forEach((element) => {
        element.className = element.className.replace(
          new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
          ' '
        )
      })
    }

    if (this.shipListDiv) {
      // 船舶列表内容标题单元格点击事件
      const titleSpans = this.shipListDiv.querySelectorAll(
        '.playShipListContent .contentTitle td span'
      )
      titleSpans.forEach((span) => {
        span.addEventListener('click', (event: any) => {
          const target = event.currentTarget
          if (target) {
            const isVisible = hasClass(target, 'unvisiable')
            const unvisiable = document.querySelectorAll(
              '.playShipListContent td span.unvisiable'
            )
            removeClass(unvisiable as any, 'unvisiable')
            this.playObjHMD = {}

            if (!isVisible) {
              addClass(
                document.querySelectorAll(
                  '.playShipListContent td span'
                ) as any,
                'unvisiable'
              )
              removeClass(target, 'unvisiable')
              this.playObjHMD = { ...this.playObjHMD, ...this.playTrackItems }
            }
          }
        })
      })

      // 船舶列表内容单元格点击事件
      const contentSpans = this.shipListDiv.querySelectorAll(
        '.playShipListContent .contentContent td span'
      )
      contentSpans.forEach((span) => {
        span.addEventListener('click', (event) => {
          event.stopPropagation()
          const target = event.currentTarget as any
          const trackId = target.closest('tr').getAttribute('el-trackID')
          const isVisible = hasClass(target, 'unvisiable')
          target.classList.toggle('unvisiable')
          this.playObjHMD[trackId] = !isVisible
        })
      })

      // 船舶列表内容行点击事件
      const contentRows = this.shipListDiv.querySelectorAll(
        '.playShipListContent .contentContent tr'
      )
      contentRows.forEach((row) => {
        row.addEventListener('click', (event: any) => {
          const shipName =
            event.currentTarget.querySelector('.shipList_td3').textContent
          if (this.options.shipListClickCallback) {
            this.options.shipListClickCallback(shipName)
          }
        })
      })

      // 船舶列表底部导出按钮点击事件
      const exportBtns = this.shipListDiv.querySelectorAll(
        '.playShipListFoot input'
      )
      exportBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const table = document.createElement('table')
          const clonedTable = document
            .querySelector(
              '.playShipList:not(.truckplayer-display-none) .playShipListContent table'
            )
            ?.cloneNode(true)
          clonedTable && table.appendChild(clonedTable)

          console.log('TODO: 导出操作')
          //  $(table).table2excel({
          //    exclude: '.noExl',
          //    name: 'Excel Document Name',
          //    filename: `${$i18n.prop('ShipC_replayShipData', '回放船舶数据') + new Date().getTime()}.xls`,
          //    fileext: '.xls',
          //    exclude_img: true,
          //    exclude_links: true,
          //    exclude_inputs: true
          //  })
        })
      })

      // 船舶列表右键菜单阻止事件
      this.shipListDiv.addEventListener('contextmenu', (event) => {
        event.preventDefault()
      })
    }
  }

  _checkLoadDataStatus(): boolean {
    return (
      !this._hasLoadDone ||
      CommUtils.msg(`数据尚未加载完成，请稍候...(${this._loadDataPercent}%)`)
    )
  }

  setFullScreen(isFullScreen = false): void {
    const _isFullScreen = isFullScreen !== false
    this.setPlayerDisplay(_isFullScreen)
  }

  _setYuanPosition(event: MouseEvent): void {
    if (
      this.playTrackItems &&
      Object.keys(this.playTrackItems).length > 0 &&
      this.isMousedown
    ) {
      if (this.draggable._newPos == null) {
        this.draggable._newPos = new L.Point(0, 0)
      }
      const offsetWidth = this.playerYuan.offsetWidth
      const halfWidth = Math.round(offsetWidth / 2)
      const mouseX = CommUtils.getMousePos(event).x
      if (this.playerTiao) {
        const elementPos = CommUtils.getElementPos(this.playerTiao)
        const leftOffset =
          mouseX - (elementPos.x + this.draggable._newPos.x) - halfWidth
        const minLeft = Math.min(this.playerTiaoW + halfWidth, leftOffset)

        this.playerYuan.style.marginLeft = `${Math.max(0, minLeft)}px`
        this.playerJindu && (this.playerJindu.style.width = `${minLeft}px`)
        this.playerPercentage =
          Math.round(
            10000 * Math.max(0, minLeft / (this.playerTiaoW + halfWidth))
          ) / 10000

        const timeDiff = this.maxTime - this.minTime
        let timeOffset = Math.round(this.playerPercentage * timeDiff)
        timeOffset =
          Math.round(timeOffset / this.options.playFrequency) *
          this.options.playFrequency
        const newTime = this.minTime + timeOffset

        this.playStart(newTime, false)
        this.playStop()
      }
    }
  }

  _setPlayerPosition(): void {
    const timeFromMin = Math.max(0, this.currentTimePosition - this.minTime)
    this.playerMinValue = 0
    this.playerMaxValue = Math.max(0, this.maxTime - this.minTime)
    if (this.playerCtime) {
      this.playerCtime.innerHTML = CanvasShipUtils.dataFormat(
        new Date(this.currentTimePosition),
        'YYYY-MM-DD HH:mm:ss'
      )
    }

    if (this.currentTimePosition === this.maxTime && this.playBtn) {
      L.DomUtil.removeClass(this.playBtn, 'start')
      L.DomUtil.removeClass(this.playBtn, 'stop')
      L.DomUtil.addClass(this.playBtn, 'start')
    }
    this.playerPercentage =
      Math.round((timeFromMin / this.playerMaxValue) * 10000) / 10000
    const fullWidth = this.playerYuan.offsetWidth
    const sliderWidth = this.playerTiaoW + Math.round(fullWidth / 2)
    this.playerPercentage = Math.max(0, this.playerPercentage)
    this.playerPercentage = Math.min(1, this.playerPercentage)
    const sliderPos = this.playerPercentage * sliderWidth
    this.playerYuan.style.marginLeft = `${sliderPos}px`
    this.playerJindu && (this.playerJindu.style.width = `${sliderPos}px`)
  }

  closeTrackPlay(): void {
    if (this._map.trackService && this.options.onCloseRemoveAllTrack) {
      this._map.trackService.removeAll()
    }
    this.removeTracks()
    this._removeShipHistoryTrack()
    this.currentTimePosition = 0
    if (this.options.closeCallback) {
      this.options.closeCallback()
    }
  }

  // 检测引入脚本
  // _checkDependence(): boolean {
  //   return LoadDependenceUtil.loadByType('table2excel')
  // }
}

const trackPlayServiceImpl = (
  map: any,
  options?: Partial<TrackPlayServiceOptions>
) => {
  return new TrackPlayServiceImpl(map, options)
}

export { TrackPlayServiceImpl, trackPlayServiceImpl }
// 使用示例
// const myMap = {} // 假设这是你的地图实例
// const trackService = new TrackPlayServiceImpl(myMap, {
//   playSpeed: 2,
//   beginTime: 10
// })
